import React from "react";
import "./Header.css";
import { Images } from "../../assets";
import Carousel from "../Carousel/Carousel";

const Header = () => {
  return (
    <header id="header" className="pt-8 flex flex-col px-5">
      <a href="/" className="z-10">
        <img
          className="logo w-[8em] sm:w-[10em] sm:mb-[5vh]"
          src={Images.MAIN_LOGO}
          alt="Logo Cavallo Bianco"
        />
      </a>

      <section className="uppercase font-bold tracking-[0.3em]">
        {/* Curved title svg */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 800 450"
          preserveAspectRatio="xMidYMid meet"
          className="w-[90vw] md:w-[50vw] mx-auto sm:mt-[-10vh] md:mt-[-15vh] lg:mt-[-20vh] xl:mt-[-25vh] lg:-mb-[2rem] xl:-mb-[3rem]"
        >
          <path
            id="curvePath"
            d="M 0 450 Q 400 150 800 450"
            fill="transparent"
            stroke="none"
          />

          <text fontSize="5rem" className="font-title fill-white">
            <textPath href="#curvePath" startOffset="50%" textAnchor="middle">
              Cavallo Bianco
            </textPath>
          </text>
        </svg>

        <h1 className="text-sm md:text-base lg:text-xl xl:text-2xl">
          Restaurant Pizzeria
          <div className="h-[0.5rem] lg:h-[1rem] xl:h-[1.5rem]" />
          Pl. Chauderon 24, 1003 Lausanne
        </h1>
      </section>

      {/* CHANGE RESERVATION LINK */}
      <a
        href="tel:+41216250970"
        className="reserve-button uppercase font-bold tracking-0.3em cursor-pointer bg-dark text-light border-2 border-light rounded-full w-4/5 sm:w-1/2 md:w-2/5 lg:w-2/5 xl:w-1/5 mt-[1em] sm:mt-[2em] md:mt-[3em] lg:mt-[7em] mb-[2em] md:mb-[4em] whitespace-nowrap hover:brightness-75 active:brightness-75 transition"
      >
        Réserver
        <br />
        ou
        <br />
        commander
      </a>

      <div className="w-full">
        <Carousel />
      </div>
    </header>
  );
};

export default Header;
